<template>
  <div class="tl w-100-ns w-80 dt center-ns">
    <div class="ml4-ns ml2 tl w-20-ns w-70 dtc">
      <router-link to="/" class="black 1 db f2-ns f3 fw4 link"><img class="logo" :src="require(`@/assets/${info.logo}`)" /></router-link>
    </div>
    <div v-if="mobile">
      <label ref="menu-btn" class="toggle pa4">
        <input
          type="checkbox" id="checkbox" 
          @click="toggleMenu()">
        <div>
          <div>
            <span class="bg-white white" />
            <span />
          </div>
          <svg>
            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" />
          </svg>
          <svg>
            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" />
          </svg>
        </div>
      </label>
      <transition name="fade">
        <div
          v-if="showMenu"
          class="nav-container w-100 dt f2"
          v-closable="{
            exclude: ['nav-mobile', 'menu-btn'],
            handler: 'onClose'
          }"
        >
          <div ref="nav-mobile" class="nav-mobile dtc v-mid">
            <!-- <div class="w-100 tc"><img class="w-70" :src="require(`@/assets/${info.logoWhite}`)" /></div> -->
            <!-- <router-link
              v-for="(route, index) in routes"
              :key="index"
              class="link tab tc center"
              :to="route.path"
            >
              <div class="pad dim dt w-100">
                <div
                  v-if="showMenu"
                  class="name dtc v-mid f3" :class="{ active: isActive(route) }"
                >
                  {{ route.name }}
                </div>
              </div>
            </router-link> -->

            <router-link class="link tab tc center" to="/">
              <div class="pad dt w-100">
                <div v-if="showMenu" class="name dtc v-mid f3" :class="{ active: isActive('Home') }">Home</div>
              </div>
            </router-link>
            <router-link class="link tab tc center" to="/about">
              <div class="pad dt w-100">
                <div v-if="showMenu" class="name dtc v-mid f3" :class="{ active: isActive('About') }">About</div>
              </div>
            </router-link>
            <div ref="insul-mobile" class="link tab tc center" @click="showDropDownMobile = !showDropDownMobile">
              <div class="pad dt w-100">
                <div v-if="showMenu" class="name dtc v-mid f3" :class="{ active: isActive('Insulation') }">Insulation 
                  <div class="dib" v-if="showDropDownMobile"><img class="moreless" src="@/assets/less.svg" /></div>
                  <div class="dib" v-if="!showDropDownMobile"><img class="moreless" src="@/assets/more.svg"/></div>
                </div>
              </div>
            </div>

            <div v-if="showDropDownMobile">
              <router-link class="link tab tc center" to="/fiberglass">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Fiberglass</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/cellulose">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Cellulose</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/denim">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Denim</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/wool">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Mineral Wool</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/rigid-board">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Rigid Board</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/spray-foam">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Spray Foam</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/hvac-supplies">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">HVAC Supplies</div>
                </div>
              </router-link>
              <router-link class="link tab tc center" to="/machines">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Machines</div>
                </div>
              </router-link>
               <router-link class="link tab tc center" to="/accessories">
                <div class="w-100 pv2">
                  <div v-if="showMenu" class="name f5">Accessories</div>
                </div>
              </router-link>
            </div>

            <router-link class="link tab tc center" to="/contact">
              <div class="pad dt w-100">
                <div v-if="showMenu" class="name dtc v-mid f3" :class="{ active: isActive('Contact') }">Contact</div>
              </div>
            </router-link>

              <div class="pt4">
                <div class="tc">
                  <div class="discount pb3 tracked ttu f2 ph2">Buy insulation <br/>direct & save 20%!</div>
                  <a class="f3 br3 pa3 link call-button bg-yellow " :href="info.tel"><i class="fa fa-phone mr3" style="font-size:24px"/>{{info.phone}}</a>
                </div>
                <div class="mt5 tc">
                  <!-- <div class="f4 white b tracked pb3">customers love us...</div> -->
                  <a class="" :href="info.yelp" target="_blank"><div class="dib w-25"><img class="ph3 " :src="require(`@/assets/${info.yelpLogo}`)" /></div></a>
                  <a class="" :href="info.map" target="_blank"><div class="dib w-25"><img class="ph3 " :src="require(`@/assets/${info.googleLogo}`)" /></div></a>
                </div>
              </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-else class="w-80 dtc v-mid tr">
      <div class="menu" >
        <router-link to="/" class="br2 btn black b pa3 link dib tracked f4" >Home</router-link>
        <router-link to="/about" class="br2 btn black b pa3 link dib tracked f4" >About</router-link>
        
        <div @click="showDropdown = !showDropdown" @mouseover="showDropdown = true" @mouseleave="showDropdown = false" ref="insul-btn" class="insul-btn btn br2 b pa3 dib tracked f4">Insulation
          <div v-closable="{
            exclude: ['insul-btn'],
            handler: 'onClose'
          }" class="drop-container pv3 dt ph3" v-if="showDropdown">
            <router-link to="/fiberglass" class="black link"><div class="drop mt2 pt3 pa2 btn b tracked f4">Fiberglass</div></router-link>
            <router-link to="/cellulose" class="black link"><div class="drop pa2 btn b tracked f4">Cellulose</div></router-link>
            <router-link to="/denim" class="black link"><div class="drop pa2 btn b tracked f4">Denim</div></router-link>
            <router-link to="/wool" class="black link"><div class="drop pa2 btn b tracked f4">Mineral Wool</div></router-link>
            <router-link to="/rigid-board" class="black link"><div class="drop pa2 btn b tracked f4">Rigid Board</div></router-link>
            <router-link to="/spray-foam" class="black link"><div class="drop pa2 btn b tracked f4">Spray Foam</div></router-link>
            <router-link to="/hvac-supplies" class="black link"><div class="drop pa2 btn b tracked f4">HVAC Supplies</div></router-link>            
            <router-link to="/machines" class="black link"><div class="drop pa2 btn b tracked f4">Machines</div></router-link>
            <router-link to="/accessories" class="black link"><div class="drop pa2 btn b tracked f4">Accessories</div></router-link>
          </div>
        </div>

        <router-link to="/contact" class="br2 btn black b pa3 link dib tracked f4" >Contact</router-link>
        <!-- <router-link :to="route.path" class="br2 btn black b pa3 link dib tracked f4" >{{route.name}}</router-link>
        <router-link :to="route.path" class="br2 btn black b pa3 link dib tracked f4" >{{route.name}}</router-link>
        <router-link :to="route.path" class="br2 btn black b pa3 link dib tracked f4" >{{route.name}}</router-link>         -->
        <!-- <router-link v-for="(route, i) in routes" :key="i" :to="route.path" class="br2 btn black b pa3 link dib tracked f4" >{{route.name}}</router-link> -->
        <div class="dib f5 pr3"><a :href="info.tel" class="white br2 pa3 link dim bg-ps-blue"><i class="fa fa-phone mr2" style="font-size:20px"/>{{info.phone}}</a></div>
      </div>
    </div>
  </div>
</template>

<script>
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};
// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () { supportsPassive = true; } 
  }));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

import Vue from 'vue'

// This variable will hold the reference to
// document's click handler
let handleOutsideClick

Vue.directive('closable', {
  bind (el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value

      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName]
          // See if this excluded element
          // is the same element the user just clicked on
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })

      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})
export default {
  name: 'NavBar',
  props: ['site', 'mobile', 'info'],
  data() {
    return {
      stopScroll: false,
      showMenu: false,
      routes: [],
      showDropdown: false,
      showDropDownMobile: false
    };
  },
  created() {
    this.$router.options.routes.forEach(route => {
      console.log(route)
      if(!route.hide) {
        this.routes.push({
            name: route.name,
            path: route.path
        })
      }
    })
  },
  watch:{
    $route (to, from){
      if(this.showMenu) {
        this.showMenu = false
        this.enableScroll()
        document.getElementById('checkbox').checked = !document.getElementById('checkbox').checked
      }
    }
  },
  methods:{
    onClose() {
      this.showMenu = false
      this.showDropdown = false
      this.showDropDownMobile = false
      this.enableScroll()
        document.getElementById('checkbox').checked = !document.getElementById('checkbox').checked
    },
    isActive: function (tab) {
      return tab.path === this.$router.currentRoute.path
    },
    toggleMenu() {
      window.scrollTo(0,0);
      this.showMenu = !this.showMenu
      if(this.showMenu) this.disableScroll()
      else this.enableScroll()
    },
    preventDefault(e) {
      e.preventDefault();
    },
    preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        this.preventDefault(e);
        return false;
      }
    },

    // call this to Disable
    disableScroll() {
      console.log('scrolling disabled')
      window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
      window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
      window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
      window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
    },

    // call this to Enable
    enableScroll() {
      console.log('scrolling enabled')
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
      window.removeEventListener(wheelEvent, this.preventDefault, wheelOpt); 
      window.removeEventListener('touchmove', this.preventDefault, wheelOpt);
      window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
    }
  }
};
</script>

<style scoped>
.moreless {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
  filter: invert(100%);
}
.insul-btn:hover {
  cursor: pointer;
}
.drop-container {
  position: absolute;
  z-index: 10000;
  margin-left: -18px;
  padding: 10px;
}
.drop {
  background: white;
  /* padding: 1rem; */
}
.pad {
  padding: .8rem;
}
.call-button {
  box-shadow: rgb(15,55,111) 5px 5px;
}
.logo {
  min-height: 55px;
  max-height: 70px;
  min-width: 200px;
}
.btn {
  position: relative;
  color: #000;
  text-decoration: none;
}

.btn:hover {
  color: #000;
}

.btn::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #000;
  visibility: hidden;
  transform: scaleX(0);
  transition: all 0.1s ease-in-out 0s;
}
.btn:hover::before {
  visibility: visible;
  transform: scaleX(.8);
}
.discount {
  font-size: 1.75rem;
}
.map {
  height: 250px;
}
.tab {
  color:#fff;
}
.nav {
  height: 3rem;
  width: 90%;
}
.menu a.router-link-exact-active, .nav-mobile a.router-link-exact-active {
}

.discount {
  font-family: 'Gochi Hand', cursive;
  text-shadow: rgb(15,55,111) 3px 3px;
  color: gold;
}

.nav-container {
  height: 95%;
  width: 80%;
  max-width: 350px;
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  right: 0;
  top: 0;
  background-color: #0f376f; /* Black fallback color */
  background-color: rgb(8, 75, 131, .9); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.7s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}
.nav-mobile {
  table-layout: fixed;
  top: 40%;
  z-index: 1001;
}
.dtr {
    display: table-row;
    width: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  /* text-transform: uppercase; */
  /* letter-spacing: .1em; */
  /* position: absolute; */
  /* bottom: 5%; */
  color:black;
  /* top: 12%; */
}
.active {
  color: #fff;
  /* opacity: .8; */
  /* font-style: italic; */
  font-weight: bold;
  text-decoration: underline;
  letter-spacing: .1em;
}

/* Hamburger Menu Styling */
.toggle {
  display: block;
  cursor: pointer;
  position: absolute;
  top: 0%;
  right: 0%;
  z-index: 1001; /* Sit on top */
}
.toggle input {
  display: none;
}
.toggle input + div {
  width: 20px;
  height: 14px;
  position: relative;
}
.toggle input + div div {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: -webkit-transform .5s ease;
  transition: transform .5s ease;
  transition: transform .5s ease, -webkit-transform .5s ease;
}
.toggle input + div div span {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
}
.toggle input + div div span:first-child {
  top: 0;
}
.toggle input + div div span:first-child:before, .toggle input + div div span:first-child:after {
  top: 0;
}
.toggle input + div div span:last-child {
  bottom: 0;
}
.toggle input + div div span:last-child:before, .toggle input + div div span:last-child:after {
  bottom: 0;
}
.toggle input + div div span:before, .toggle input + div div span:after {
  content: '';
  display: block;
  width: 47%;
  height: 2px;
  border-radius: 1px;
  background: #0f376f;
  position: absolute;
  -webkit-backface-visibility: hidden;
  transition: border-radius .3s ease, background .4s ease, -webkit-transform .5s ease;
  transition: transform .5s ease, border-radius .3s ease, background .4s ease;
  transition: transform .5s ease, border-radius .3s ease, background .4s ease, -webkit-transform .5s ease;
}
.toggle input + div div span:before {
  left: 0;
  -webkit-transform-origin: 0 50%;
          transform-origin: 0 50%;
  -webkit-transform: translate(1px, 0) scaleX(1.1);
          transform: translate(1px, 0) scaleX(1.1);
}
.toggle input + div div span:after {
  right: 0;
  -webkit-transform-origin: 100% 50%;
          transform-origin: 100% 50%;
  -webkit-transform: translate(-1px, 0) scaleX(1.1);
          transform: translate(-1px, 0) scaleX(1.1);
}
.toggle input + div svg {
  display: block;
  fill: none;
  stroke: #0f376f;
  stroke-width: 2px;
  width: 44px;
  height: 44px;
  stroke-linecap: round;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -22px 0 0 -22px;
  stroke-dasharray: 0 82.801 8 82.801;
  stroke-dashoffset: 82.801;
  -webkit-transform-origin: 50% 50%;
          transform-origin: 50% 50%;
  -webkit-backface-visibility: hidden;
  -webkit-transform: scale(1);
          transform: scale(1);
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, stroke .4s ease, -webkit-transform .5s ease;
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease;
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease, -webkit-transform .5s ease;
}
.toggle input + div svg:nth-child(3) {
  -webkit-transform: rotate(180deg) scale(1);
          transform: rotate(180deg) scale(1);
}
.toggle input:checked + div div {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}
.toggle input:checked + div div span:before, .toggle input:checked + div div span:after {
  background: #fff;
}
.toggle input:checked + div div span:first-child:before {
  -webkit-transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
          transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
}
.toggle input:checked + div div span:first-child:after {
  -webkit-transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
          transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
}
.toggle input:checked + div div span:last-child:before {
  -webkit-transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
          transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
}
.toggle input:checked + div div span:last-child:after {
  -webkit-transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
          transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
}
.toggle input:checked + div svg {
  stroke-dashoffset: 62;
  stroke-dasharray: 0 82.801 62 82.801;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  stroke:#fff;
;
}
.toggle input:checked + div svg:nth-child(3) {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

html {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: inherit;
}
*:before, *:after {
  box-sizing: inherit;
}
</style>
